var $ = require("jquery");
require("timepicker");

var Timepicker = Backbone.View.extend(
  {
    initialize: function() {
      const value = this.$el.val(); // Preserve selected value

      this.initTimepicker();
      this.updateTimeOptions(value);
    },

    /**
     * Initialize the timepicker with parsed settings.
     */
    initTimepicker: function() {
      try {
        const settings = this.$el.attr("data-settings");
        const parsedSettings = settings ? JSON.parse(settings) : {};

        this.$el.timepicker(parsedSettings);
      } catch (error) {
        console.error("Error parsing data-settings:", error);
      }
    },

    /**
     * Convert seconds-based time values to human-readable format in options and select default time.
     * @param {string} value - The initial value from the input field.
     */
    updateTimeOptions: function(value) {
      let defaultSelected = false;
      let selectedTime = null;

      this.$el
        .siblings("select.ui-timepicker-select")
        .find("option")
        .each(function() {
          const $option = $(this);
          const seconds = parseInt($option.val(), 10);

          if (!isNaN(seconds)) {
            const formattedTime = Timepicker.formatTime(seconds);

            const optionValue = Timepicker.normalizeValue(
              $option.attr("value")
            );
            var optionText = Timepicker.normalizeValue($option.text());

            if (optionValue !== optionText) {
              $option.attr("value", formattedTime);
            }

            // Check if this option should be selected as the default
            if (value && Timepicker.normalizeValue(value) === optionText) {
              $option.prop("selected", true);
              defaultSelected = true;
              selectedTime = $option.text();
            }
          }
        });

      // Ensure input field is updated if a default selection was found
      if (defaultSelected) {
        this.$el.attr("value", selectedTime).val(selectedTime);
      }
    }
  },
  {
    /**
     * Convert seconds into a 12-hour AM/PM time format.
     * @param {number} seconds - Time in seconds (e.g., 3600 = 1:00 AM)
     * @returns {string} Formatted time (e.g., "2:15 PM")
     */
    formatTime: function(seconds) {
      const hours24 = Math.floor(seconds / 3600);
      const minutes = (seconds % 3600) / 60;
      const ampm = hours24 >= 12 ? "PM" : "AM";
      let hours12 = hours24 % 12 || 12; // Convert to 12-hour format

      return `${hours12
        .toString()
        .padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${ampm}`;
    },

    /**
     * Normalize a string by trimming spaces and removing leading zeros.
     * @param {string} value - The string to normalize.
     * @returns {string} Normalized value without leading zeros and extra spaces.
     */
    normalizeValue: function(value) {
      if (!value) return "";

      let normalized = value
        .toString()
        .trim()
        .toUpperCase()
        .replace(/\s+/g, "") // Remove all spaces
        .replace(/[:.]/g, ""); // Remove colons `:` and dots `.`

      // Match hours, minutes, and optional seconds (e.g., 12:30:45AM -> 12:30AM)
      let match = normalized.match(/^(\d{1,2})(\d{2})(?:\d{2})?(AM|PM)$/);
      if (match) {
        let hours = parseInt(match[1], 10);
        let minutes = match[2];
        let period = match[3];

        // Convert 24-hour format errors (e.g., 13PM -> 01PM)
        if (hours > 12) {
          hours = hours % 12 || 12;
        }

        // Ensure leading zero on single-digit hours
        return `${hours.toString().padStart(2, "0")}${minutes}${period}`;
      }

      return normalized; // Return as-is if no match found
    }
  }
);

module.exports = Timepicker;
